import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import { JQModal } from "@my-dld/components/Popup/Utils";

interface Props {
	onDismiss: () => void;
	onAddMore: () => void;
	onCreateContract: () => void;
}

interface State {
	isAction?: boolean;
}

class SuccessPopup extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	render() {
		return <Popup
			id={ "SuccessPopup" }
			modalMainContainer={ "modal fade" }
			clickOutsideToDismiss={ false }
			showCloseButton={ true }
			closeClass={ "close modal-close-svg-icon" }
			closeSpanClass={ "close-svg-icon" }
			modalBodyContainer={ "modal-body" }
			showIcon={ false }
			title={ Strings.confirmation }
			autoOpenMount={ true }
			modalFooterContainer={ "modal-footer d-flex justify-content-center" }
			footer={ <button
				type="button" className="btn btn_1 btn_style1"
				data-uw-styling-context="true" data-bs-dismiss="modal">{ Strings.close }</button> }
			onDismiss={ this.onDismiss }>
			<div className="">
				<div className="check-icon">
					<i className="fa fa-check"/>
				</div>
				<p className="text-center">{ Strings.add_your_property_success }</p>
				<div className="text-center">
					<button
						type="button" className="btn btn-link unrderline font-size14"
						data-uw-styling-context="true"
						onClick={ this.onAddMore }>{ Strings.add_more_properties }</button>
					<button
						type="button" className="btn btn-link unrderline font-size14"
						data-uw-styling-context="true"
						onClick={ this.onCreateContract }>{ Strings.create_tenancy_contract }</button>
				</div>
			</div>
		</Popup>;
	}

	private onDismiss = () => {
		if ( this.state.isAction == undefined ) {
			JQModal( "SuccessPopup" ).hide();
			this.props.onDismiss();
		}
	};

	private onAddMore = () => {
		this.setState( {
			isAction: true,
		}, () => {
			JQModal( "SuccessPopup" ).hide();
			this.props.onAddMore();
		} );
	};

	private onCreateContract = () => {
		this.setState( {
			isAction: true,
		}, () => {
			this.props.onCreateContract();
		} );
	};
}

export default SuccessPopup;
